export default __webpack_public_path__ + "static/media/large-luggage_2.6467c466.svg";